export default function Reassurances() {
  const items = [
    { icon: "ri-time-line", text: "Intervention 24h" },
    { icon: "ri-file-list-3-line", text: "Devis gratuit" },
    { icon: "ri-check-double-line", text: "Toutes marques" },
    { icon: "ri-shield-check-line", text: "Garantie 10 ans" },
  ];

  return (
    <section className="bg-white border-b border-brand-border py-6 md:py-8">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {items.map((item) => (
            <div
              key={item.text}
              className="flex items-center gap-3 justify-center md:justify-start"
            >
              <div className="w-10 h-10 flex items-center justify-center text-brand-cyan">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <span className="text-brand-text text-sm md:text-base font-medium">
                {item.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}